// src/components/EditAlert.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Container,
    Typography,
    Box,
    Paper,
    Grid,
    TextField,
    Button,
    MenuItem
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

const EditAlert = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [alertData, setAlertData] = useState(null);
    const [form, setForm] = useState({
        alert_type: '',
        service_type: '',
        severity: '',
        message: '',
        status: ''
    });
    const API_URL = process.env.REACT_APP_API_URL || '';

    useEffect(() => {
        const fetchAlert = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/alerts/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setAlertData(response.data);
                setForm({
                    alert_type: response.data.alert_type || '',
                    service_type: response.data.service_type || '',
                    severity: response.data.severity || '',
                    message: response.data.message || '',
                    status: response.data.status || ''
                });
            } catch (error) {
                console.error('Error fetching alert:', error);
            }
        };
        fetchAlert();
    }, [id, token]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.put(`${API_URL}/api/alerts/${id}`, form, {
                headers: { Authorization: `Bearer ${token}` }
            });
            navigate('/alerts');
        } catch (error) {
            console.error('Error updating alert:', error);
        }
    };

    if (!alertData) {
        return <Typography>Ładowanie alertu...</Typography>;
    }

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h4" gutterBottom>Edycja alertu</Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Typ alertu"
                                    name="alert_type"
                                    value={form.alert_type}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="system">system</MenuItem>
                                    <MenuItem value="notification">notification</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Typ usługi"
                                    name="service_type"
                                    value={form.service_type}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="aiteams">aiteams</MenuItem>
                                    <MenuItem value="pricemonit">pricemonit</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Ważność"
                                    name="severity"
                                    value={form.severity}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="low">low</MenuItem>
                                    <MenuItem value="medium">medium</MenuItem>
                                    <MenuItem value="high">high</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Status"
                                    name="status"
                                    value={form.status}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="new">new</MenuItem>
                                    <MenuItem value="read">read</MenuItem>
                                    <MenuItem value="resolved">resolved</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Wiadomość"
                                    name="message"
                                    value={form.message}
                                    onChange={handleChange}
                                    multiline
                                    rows={4}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">
                                    Zapisz zmiany
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
};

export default EditAlert;